export default "__VITE_ASSET__BXErZ_8K__"